import type { StackableOverlayId } from './overlayStack';

export type OverlayOpacities = Partial<Record<StackableOverlayId, number>>;

export const defaultOverlayOpacities: Record<StackableOverlayId, number> = {
  newHeatmap: 1,
  personalHeatmap: 1,
  slopeAngle: 0.35,
  highDefTerrain: 1,
  precipitation: 0.55,
  temperature: 0.55,
  groundConditions: 1,
  snowDepth: 0.55,
  publicLands: 1,
  privateLands: 1,
  wildfire: 1,
  fallFoliage: 1
};

export const singleOverlayOpacityIds = [
  'newHeatmap',
  'precipitation',
  'temperature',
  'snowDepth',
  'groundConditions',
  'slopeAngle',
  'fallFoliage'
] as const satisfies readonly StackableOverlayId[];

export const hasSingleOverlayOpacity = (styleId: StackableOverlayId) => (singleOverlayOpacityIds as readonly StackableOverlayId[]).includes(styleId);

export const clampOpacity = (opacity: number) => Math.min(Math.max(opacity, 0), 1);

export const getOverlayOpacity = (overlayOpacities: OverlayOpacities, styleId: StackableOverlayId) =>
  overlayOpacities[styleId] ?? defaultOverlayOpacities[styleId];

export const getOverlayOpacityPercent = (overlayOpacities: OverlayOpacities, styleId: StackableOverlayId) =>
  Math.round(getOverlayOpacity(overlayOpacities, styleId) * 100);
